export const apiURL = process.env.REACT_APP_BASE_URL;

async function client(
  endpoint: any,
  { data, headers: customHeaders, ...customConfig }: any = {}
) {
  const token = localStorage?.getItem("token");

  const config = {
    method: data ? "POST" : "GET",
    body: data
      ? data?.access_token
        ? undefined
        : data instanceof FormData
        ? data
        : JSON.stringify(data)
      : undefined,
    headers: {
      Authorization:
        endpoint === "auth/resetPassword"
          ? data?.token
          : token
          ? `${token}`
          : "",
      ...(!data || data instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...customHeaders,
    },
    ...customConfig,
  };

  return await window
    .fetch(`${apiURL}/${endpoint}`, config)
    .then(async (response) => {
      if (response.ok) {
        const jsonData = await response.json();
        return jsonData;
      } else {
        const jsonData = await response.json();
        return Promise.reject(jsonData);
      }
    });
}

export { client };
